import { useMutation } from '@tanstack/react-query'

import { request } from 'Lib/axios'
import { ExtractFnReturnType } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'

import { MODULE_NAMES } from './helper'

export type ModuleViewedResponse = null

type QueryFnType = typeof setModuleViewed

const setModuleViewed = (accountId: number) =>
  request<{ data: ModuleViewedResponse }>({
    url: `accounts/${accountId}/setup/setCeModuleViewed`,
    method: 'POST',
    data: { ceModule: MODULE_NAMES.Gateway },
  })

export const useSetModuleFirstView = () => {
  const { accountId } = useUserStore()

  const mutation = useMutation<ExtractFnReturnType<QueryFnType>>({
    mutationFn: () => setModuleViewed(accountId),
    mutationKey: ['SetModuleFirstViewGW', accountId],
  })

  const data = mutation.data && mutation.data instanceof Error ? undefined : mutation.data

  return { ...mutation, data }
}
